import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=3c5e8975&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=3c5e8975&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e8975",
  null
  
)

export default component.exports